import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from '../../shared/services/cookie.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const cookieService = inject(CookieService);

  const token = cookieService.getCookie('token');
  if (token) {
    return true;
  }
  router.navigate(['auth/login']);
  localStorage.clear();
  return false;
};